import { MESSAGING_ACCESS } from './Scopes';
import { CONTAINER_TYPES } from 'web-interactives-data/constants/ContainerConstants';
import { gate } from 'hub-http/gates';
import I18n from 'I18n';
export const GENERIC_CONTAINER_TYPES = {
  EMBED: 'embed',
  POPUP: 'popup'
};
export const TEMPLATE_CATEGORIES = {
  EVENT: 'EVENT',
  CONTENT: 'CONTENT',
  LEAD_CAPTURE: 'LEAD_CAPTURE',
  NEWSLETTER: 'NEWSLETTER',
  CLICK_TO_CHAT: 'CLICK_TO_CHAT',
  ARTICLE: 'ARTICLE',
  OFFER: 'OFFER',
  NOTIFICATION: 'NOTIFICATION',
  BLANK: 'BLANK',
  FORM: 'FORM'
};
export const isTemplateCategory = value => value in TEMPLATE_CATEGORIES;
export const getGenericContainerType = template => template.containerType === CONTAINER_TYPES.EMBEDDED ? GENERIC_CONTAINER_TYPES.EMBED : GENERIC_CONTAINER_TYPES.POPUP;
export const getTemplateTitle = template => {
  const langKey = `create.defaultTemplates.${template.filename.toLowerCase()}.title`;
  // @ts-expect-error Not migrated yet
  return I18n.lookup(langKey) ? I18n.text(langKey) : template.displayName || '';
};

// Hydrates interactive properties to templates not available from service, indexed by template path.
export const TemplateSchema = {
  '@hubspot/calls-to-action/templates/webinar-registration-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.popup.title',
      descriptionLangKey: 'manage.states.emptyState.templates.popup.description'
    }
  },
  '@hubspot/calls-to-action/templates/newsletter-subscription-banner.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.BANNER,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER, TEMPLATE_CATEGORIES.FORM],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.banner.title',
      descriptionLangKey: 'manage.states.emptyState.templates.banner.description'
    }
  },
  '@hubspot/calls-to-action/templates/signup-embedded.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.button.title',
      descriptionLangKey: 'manage.states.emptyState.templates.button.description'
    }
  },
  '@hubspot/calls-to-action/templates/14-day-free-trial-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.OFFER]
  },
  '@hubspot/calls-to-action/templates/customer-update.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.BANNER,
    templateCategories: [TEMPLATE_CATEGORIES.NOTIFICATION]
  },
  '@hubspot/calls-to-action/templates/download-email-templates.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/download-free-ebook-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.CONTENT, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/event-registration-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.EVENT]
  },
  '@hubspot/calls-to-action/templates/new-embedded-cta.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.CONTENT]
  },
  '@hubspot/calls-to-action/templates/guide-download-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.CONTENT]
  },
  '@hubspot/calls-to-action/templates/join-our-community-template.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER]
  },
  '@hubspot/calls-to-action/templates/live-webinar-registration-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.EVENT]
  },
  '@hubspot/calls-to-action/templates/maintenance-notification-banner.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.BANNER,
    templateCategories: [TEMPLATE_CATEGORIES.NOTIFICATION]
  },
  '@hubspot/calls-to-action/templates/newsletter-subscription-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/product-demo-banner.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.BANNER,
    templateCategories: [TEMPLATE_CATEGORIES.OFFER]
  },
  '@hubspot/calls-to-action/templates/referral-card-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.OFFER]
  },
  '@hubspot/calls-to-action/templates/special-offer-embedded-cta.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.OFFER]
  },
  '@hubspot/calls-to-action/templates/sprout-slide-in-newsletter.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER]
  },
  '@hubspot/calls-to-action/templates/webinar-discount-offer-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/whatsapp-chat-compact-embeddable-cta.html': {
    scope: MESSAGING_ACCESS,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.CLICK_TO_CHAT]
  },
  '@hubspot/calls-to-action/templates/whatsapp-chat-compact-floating.html': {
    scope: MESSAGING_ACCESS,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.CLICK_TO_CHAT]
  },
  '@hubspot/calls-to-action/templates/whatsapp-chat-embeddable-cta.html': {
    scope: MESSAGING_ACCESS,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.CLICK_TO_CHAT]
  },
  '@hubspot/calls-to-action/templates/whatsapp-chat-slide-in-cta.html': {
    scope: MESSAGING_ACCESS,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.CLICK_TO_CHAT]
  },
  '@hubspot/calls-to-action/templates/workshop-registration-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.EVENT]
  },
  '@hubspot/calls-to-action/templates/blog-article-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.ARTICLE]
  },
  '@hubspot/calls-to-action/templates/page-redirect-template.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.ARTICLE]
  },
  '@hubspot/calls-to-action/templates/discount-offer-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE]
  },
  '@hubspot/calls-to-action/templates/mailing-list-sing-up-pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/video-sign-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.NEWSLETTER]
  },
  '@hubspot/calls-to-action/templates/leadflow-callout.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE]
  },
  '@hubspot/calls-to-action/templates/simple-text-cta.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE]
  },
  '@hubspot/calls-to-action/templates/embedded-asset.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK]
  },
  '@hubspot/calls-to-action/templates/embedded-button.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.button.title',
      descriptionLangKey: 'manage.states.emptyState.templates.button.description'
    }
  },
  '@hubspot/calls-to-action/templates/embedded-image.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.EMBEDDED,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK]
  },
  '@hubspot/calls-to-action/templates/pop-up.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.popup.title',
      descriptionLangKey: 'manage.states.emptyState.templates.popup.description'
    }
  },
  '@hubspot/calls-to-action/templates/slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.slideIn.title',
      descriptionLangKey: 'manage.states.emptyState.templates.slideIn.description'
    }
  },
  '@hubspot/calls-to-action/templates/sticky-banner.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.BANNER,
    templateCategories: [TEMPLATE_CATEGORIES.BLANK],
    emptyStateTemplateMeta: {
      titleLangKey: 'manage.states.emptyState.templates.banner.title',
      descriptionLangKey: 'manage.states.emptyState.templates.banner.description'
    }
  },
  '@hubspot/calls-to-action/templates/black-friday-countdown-no1.html': {
    scope: null,
    gate: gate('WebInteractives:CountdownModule'),
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/black-friday-countdown-no2.html': {
    scope: null,
    gate: gate('WebInteractives:CountdownModule'),
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/black-friday-countdown-no3.html': {
    scope: null,
    gate: gate('WebInteractives:CountdownModule'),
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/christmas-countdown-no1.html': {
    scope: null,
    gate: gate('WebInteractives:CountdownModule'),
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/christmas-countdown-no2.html': {
    scope: null,
    gate: gate('WebInteractives:CountdownModule'),
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE, TEMPLATE_CATEGORIES.FORM]
  },
  '@hubspot/calls-to-action/templates/meeting-popup.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.MODAL,
    templateCategories: [TEMPLATE_CATEGORIES.LEAD_CAPTURE],
    isNew: true
  },
  '@hubspot/calls-to-action/templates/podcast-slide-in.html': {
    scope: null,
    gate: null,
    containerType: CONTAINER_TYPES.SLIDE_IN,
    templateCategories: [TEMPLATE_CATEGORIES.CONTENT],
    isNew: true
  }
};